import createRequest from '../core/request'

/**
 * 获取营销邮件列表
 */
export function get_edm_list(params, data) {
  return createRequest('SyncAPI').post('/get_edm_list', data, {
    params
  })
}

/**
 * 获取营销邮件各类数量
 */
export function get_edm_num(params) {
  return createRequest('SyncAPI').get('/get_edm_num', {
    params
  })
}

/**
 * 获取发件人列表
 */
export function get_edm_sender_list(params) {
  return createRequest('SyncAPI').get('get_edm_sender_list', {
    params
  })
}

/**
 * 上传附件
 */
export function upload_edm_attachment(data) {
  return createRequest('SyncAPI').post('upload_edm_attachment', data)
}

/**
 * 获取所有模板列表
 */
export function get_edm_all_tpl_list(params) {
  return createRequest('SyncAPI').get('get_edm_all_tpl_list', {
    params
  })
}

/**
 * 获取标签列表
 */
export function get_tag_list(params) {
  return createRequest('TagAPI').get('tag_list', {
    params
  })
}

/**
 * 提交邮件详情（下一步）
 */
export function submit_email(params, data) {
  return createRequest('SyncAPI').post('submit_email', data, {
    params
  })
}

/**
 * 邮件模板详情
 */
export function get_edm_tpl_detail(params) {
  return createRequest('SyncAPI').get('get_edm_tpl_detail', {
    params
  })
}

/**
 * 获取营销邮件所有信息
 */
export function get_edm_info(params) {
  return createRequest('SyncAPI').get('get_edm_info', {
    params
  })
}

/**
 * 获取邮件详情
 */
export function get_edm_detail(params) {
  return createRequest('SyncAPI').get('get_edm_detail', {
    params
  })
}

/**
 * 最终确认发送营销邮件
 */
export function confirm_email(params, data) {
  return createRequest('SyncAPI').post('confirm_email', data, {
    params
  })
}

/**
 * 发送测试邮件
 */
export function send_test_email(params, data) {
  return createRequest('SyncAPI').post('send_test_email', data, {
    params
  })
}

/**
 * 邮件预览
 */
export function get_edm_preview(params) {
  return createRequest('SyncAPI').get('get_edm_preview', {
    params
  })
}

/**
 * 获取邮件发送信息（结果）
 */
export function get_email_detail(params) {
  return createRequest('SyncAPI').get('get_email_detail', {
    params
  })
}

/**
 * 重新发送失败邮件
 */
export function resend_failed_email(params, data) {
  return createRequest('SyncAPI').post('resend_failed_email', data, {
    params
  })
}

/**
 * 取消定时发送
 */
export function cancel_edm_task(params) {
  return createRequest('SyncAPI').get('cancel_edm_task', {
    params
  })
}

/**
 * 获取邮件内容
 */
export function get_edm_content(params) {
  return createRequest('SyncAPI').get('get_edm_content', {
    params
  })
}

/**
 * 复制草稿
 */
export function copy_edm_draft(params) {
  return createRequest('SyncAPI').get('copy_edm_draft', {
    params
  })
}

/**
 * 删除草稿
 */
export function del_edm_draft(params) {
  return createRequest('SyncAPI').get('del_edm_draft', {
    params
  })
}

/**
 * 获取模板列表
 */
export function get_edm_tpl_list(params) {
  return createRequest('SyncAPI').get('get_edm_tpl_list', {
    params
  })
}

/**
 * 创建模板
 */
export function create_edm_tpl(params, data) {
  return createRequest('SyncAPI').post('create_edm_tpl', data, {
    params
  })
}

/**
 * 复制模板
 */
export function copy_edm_tpl(params) {
  return createRequest('SyncAPI').get('copy_edm_tpl', {
    params
  })
}

/**
 * 删除模板
 */
export function delete_edm_tpl(params) {
  return createRequest('SyncAPI').get('delete_edm_tpl', {
    params
  })
}

/**
 * 获取过滤列表
 */
export function get_filter_list(params) {
  return createRequest('SyncAPI').get('get_filter_list', {
    params
  })
}

/**
 * 删除过滤关键词
 */
export function del_edm_filter(params) {
  return createRequest('SyncAPI').get('del_edm_filter', {
    params
  })
}

/**
 * 添加过滤关键词
 */
export function add_edm_filter(params, data) {
  return createRequest('SyncAPI').post('add_edm_filter', data, {
    params
  })
}

/**
 * 再发一封
 */
export function copy_edm_task(params) {
  return createRequest('SyncAPI').get('copy_edm_task', {
    params
  })
}

/**
 * 账户余额查询
 */
export function get_product_info(params) {
  return createRequest('CORPAPI').get('/product/query_product_info', {
    params
  })
}

/**
 * 退订
 */
export function edm_unsubscribe(data) {
  const key = data.area == 1 ? 'UNSUBSCRIBE_AREA1' : 'UNSUBSCRIBE_AREA2'
  return createRequest(key).post('/edm_unsubscribe', data)
}

/**
 * 获取发件人信息
 */
export function get_edm_sender_info(params) {
  return createRequest('SyncAPI').get('/get_edm_sender_info', {
    params
  })
}
/**
 * 下载营销邮件详情
 */
export function download_edm_excel(params) {
  return createRequest('SyncAPI').get('/download_email_detail', {
    params
  })
}

/**
 * 获取营销邮件弹窗和红点
 */
export function get_edm_pop(params) {
  return createRequest('CORPAPI').get('/admin/login_info', {
    params
  })
}

/**
 * 上报用户点击特定事件
 */
export function report_edm_click(params) {
  return createRequest('CORPAPI').get('/admin/report_user_event', {
    params
  })
}

/**
 * 获取AI 场景参数
 */
export function get_scene_param(params) {
  return createRequest('SyncAPI').get('/edm/ai/get_scene_param', {
    params
  })
}

/**
 * ai反馈标签
 */
export function get_feedback_tag(params, data) {
  return createRequest('SyncAPI').post('/ai/get_feedback_tag', data, {
    params
  })
}

/**
 * ai反馈
 */
export function user_feedback(params, data) {
  return createRequest('SyncAPI').post('/ai/feedback', data, {
    params
  })
}
